import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/react';
import packageJson from '../package.json';

// Ensure this file is imported BEFORE React renders (import in index.js)
const dsn = process.env.REACT_APP_SENTRY_DSN || process.env.SENTRY_DSN; // support single DSN env naming

if (dsn) {
    Sentry.init({
        dsn,
        environment: process.env.NODE_ENV,
        release: `frontend@${packageJson.version}`,
        integrations: [
            browserTracingIntegration({
                tracePropagationTargets: ["localhost", /taas-v2\.dev\.codedtech\.tech/]
            })
        ],
        tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    });
}

export { Sentry };
